module.exports = __webpack_public_path__ + "img/box_pro_five_2.7fc0f4d2.jpg";